import { mapDraftToServerInputs } from '../../components/EditCandidateProfile/map-draft-to-server-inputs';

const buildCandidateEdit = (candidate, task) => {
  const { updatedAt: holdingDataUpdatedAt, ...holdingData } = task?.holdingData || {};
  const baseDraft = candidate?.stagingDraft || {};
  const holdingDataIsMoreRecent = Boolean(task?.holdingData) && holdingDataUpdatedAt > candidate?.updatedAt;
  const candidateDraft = holdingDataIsMoreRecent
    // holdingData may contain partial edits and can omit `name`; keep the
    // candidate's stagingDraft as the base so the name is always present.
    ? { ...baseDraft, ...holdingData }
    : baseDraft;

  return {
    ...candidateDraft,
    // Contact is stored directly on the candidate rather than in stagingDraft.
    // Prefer newer autosaved task data, then fall back to the persisted candidate.
    contact: candidateDraft.contact || candidate?.contact || [],
    removedAutoContent: candidateDraft.removedAutoContent || candidate?.removedAutoContent,
  };
};

const markEmptyLinkCategoriesAsMissing = (draft = {}) => {
  const references = draft?.references || {};
  const categories = (references.categories || []).filter(Boolean);
  const categoriesWithLinkChecks = ['website', 'social'].reduce((acc, type) => {
    const categoryIndex = acc.findIndex(c => c.type === type);
    const category = categoryIndex >= 0 ? acc[categoryIndex] : { type, sources: [] };
    const sources = category.sources || [];
    const categoryChecked = {
      ...category,
      sources,
      missing: sources.length > 0 ? category.missing : true,
    };

    if (categoryIndex >= 0) {
      acc[categoryIndex] = categoryChecked;
    } else {
      acc.push(categoryChecked);
    }

    return acc;
  }, categories.slice());

  return {
    ...draft,
    references: {
      ...references,
      categories: categoriesWithLinkChecks,
    },
  };
};

const buildLinkCandidateCompletionData = (candidateEdit) => {
  const draftForCompletion = markEmptyLinkCategoriesAsMissing(candidateEdit);
  return {
    ...mapDraftToServerInputs(draftForCompletion),
    contact: candidateEdit?.contact || [],
  };
};

export {
  buildCandidateEdit,
  buildLinkCandidateCompletionData,
  markEmptyLinkCategoriesAsMissing,
};
